export const FACEBOOK_PAGE_URL =
  'https://www.facebook.com/share/1EJ9FhauYo/?mibextid=wwXIfr';
